var MetadataInfo = /** @class */ (function () {
    function MetadataInfo(abc, name, keys, values) {
        this.abc = abc;
        this.name = name;
        this.keys = keys;
        this.values = values;
        // ...
    }
    MetadataInfo.prototype.getValue = function (key) {
        for (var i = 0; i < this.keys.length; i++)
            if (this.keys[i] === key)
                return this.values[i];
        return null;
    };
    return MetadataInfo;
}());
export { MetadataInfo };
